import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { GoogleOAuthProvider } from "@react-oauth/google";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import './index.scss'
import App from './App.tsx'
import { SpinnerProvider } from './components/spinner/spinnerProvider.tsx';
import { ToastProvider } from './components/toast/toastPrivider.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
        <ToastProvider>
          <SpinnerProvider>
            <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
              <App />
            </GoogleOAuthProvider>
          </SpinnerProvider>
        </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
)
